import React from 'react';

const Error = () => (
  <span className="map-error">Hubo un error al listar los consultorios</span>
);

export default Error;
